/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEyeBolt = createReactComponent("eye-bolt", "IconEyeBolt", [
  ["path", { d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M13.1 17.936a9.28 9.28 0 0 1 -1.1 .064c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6",
      key: "svg-1"
    }
  ],
  ["path", { d: "M19 16l-2 3h4l-2 3", key: "svg-2" }]
]);

export { IconEyeBolt as default };
//# sourceMappingURL=IconEyeBolt.js.map
